import type { BoxListItem, BoxProductItem } from "../../../api/WarehouseApi";
import { Box as BoxModel } from "../../../stores/Box";
import { Product } from "../../../stores/Product";
import { normalizeTypeTags } from "../../../utils/typeTags";

export function createBoxModelFromListItem(item: BoxListItem): BoxModel {
  return new BoxModel({
    id: item.id,
    name: item.name,
    photo: item.photo,
    typeTags: normalizeTypeTags(item.typeTags),
    description: item.description,
    parentId: item.parentId,
  });
}

export function createProductModelFromBoxItem(item: BoxProductItem): Product {
  return new Product({
    id: item.id,
    name: item.name,
    photo: item.photo,
    photos: item.photos,
    description: item.description,
    typeTags: normalizeTypeTags(item.typeTags),
    measure: item.measure,
    quantity: item.quantity,
    parentId: item.parentId,
    manufacturingDate: item.manufacturingDate,
    expiryDate: item.expiryDate,
  });
}
